// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../node_modules/css-loader/dist/runtime/api.js";
import ___CSS_LOADER_GET_URL_IMPORT___ from "../node_modules/css-loader/dist/runtime/getUrl.js";
var ___CSS_LOADER_URL_IMPORT_0___ = new URL("../src/Fonts/Montserrat-SemiBold.otf", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_1___ = new URL("../src/Fonts/Montserrat-LightItalic.otf", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_2___ = new URL("../src/Fonts/Montserrat-Light.otf", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_3___ = new URL("../src/Fonts/Montserrat-MediumItalic.otf", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_4___ = new URL("../src/Fonts/MontserratAlternates-ThinItalic.otf", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_5___ = new URL("../src/Fonts/MontserratAlternates-LightItalic.otf", import.meta.url);
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
var ___CSS_LOADER_URL_REPLACEMENT_0___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_0___);
var ___CSS_LOADER_URL_REPLACEMENT_1___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_1___);
var ___CSS_LOADER_URL_REPLACEMENT_2___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_2___);
var ___CSS_LOADER_URL_REPLACEMENT_3___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_3___);
var ___CSS_LOADER_URL_REPLACEMENT_4___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_4___);
var ___CSS_LOADER_URL_REPLACEMENT_5___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_5___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `@font-face {
	font-family: 'Montserrat-large';
	src: url(${___CSS_LOADER_URL_REPLACEMENT_0___}) format('opentype');
    /* font-weight: normal; */
    font-weight: 600;
	font-style: normal;
    /* font-size:0.9rem !important; */
    font-size:0.8rem !important;
}
@font-face {
	font-family: 'Montserrat-small';
	src: url(${___CSS_LOADER_URL_REPLACEMENT_1___}) format('opentype');
	font-weight: normal;
	font-style: normal;
    /* font-size:0.7rem !important; */
    font-size:0.6rem !important;
}
@font-face {
	font-family: 'Montserrat-medium';
	src: url(${___CSS_LOADER_URL_REPLACEMENT_2___}) format('opentype');
	font-weight: normal;
	font-style: normal;
    /* font-size:0.8rem !important; */
    font-size:0.7rem !important;
}
@font-face {
	font-family: 'Montserrat-mdm-italic';
	src: url(${___CSS_LOADER_URL_REPLACEMENT_3___}) format('opentype');
    /* font-weight: normal; */
    font-weight: normal;
	font-style: italic;
    font-size:0.7rem !important;
    /* font-size:0.9rem !important; */
}
@font-face {
	font-family: 'Montserrat-Thin-italic';
	src: url(${___CSS_LOADER_URL_REPLACEMENT_4___}) format('opentype');
	font-weight: normal;
	font-style: normal;
    /* font-size:0.8rem !important; */
    font-size:0.9rem !important;
}
@font-face {
	font-family: 'Montserrat-Light-italic';
	src: url(${___CSS_LOADER_URL_REPLACEMENT_5___}) format('opentype');
	font-weight: normal;
	font-style: normal;
    /* font-size:0.8rem !important; */
    font-size:0.9rem !important;
}

.dropdown-icon-size {
    font-size: 1vh !important;
}


.video-btn-icon-size {
    font-size: 1.7vh !important;
    padding: 0.3rem;
}

body {
  margin: 0;
  font-family: 'Montserrat';
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
}

code {
  font-family: source-code-pro, Menlo, Monaco, Consolas, 'Courier New',
    monospace;
}


.width-100{
    width: 100% !important;
}`, "",{"version":3,"sources":["webpack://./src/index.css"],"names":[],"mappings":"AAAA;CACC,+BAA+B;CAC/B,+DAAmE;IAChE,yBAAyB;IACzB,gBAAgB;CACnB,kBAAkB;IACf,iCAAiC;IACjC,2BAA2B;AAC/B;AACA;CACC,+BAA+B;CAC/B,+DAAsE;CACtE,mBAAmB;CACnB,kBAAkB;IACf,iCAAiC;IACjC,2BAA2B;AAC/B;AACA;CACC,gCAAgC;CAChC,+DAAgE;CAChE,mBAAmB;CACnB,kBAAkB;IACf,iCAAiC;IACjC,2BAA2B;AAC/B;AACA;CACC,oCAAoC;CACpC,+DAAuE;IACpE,yBAAyB;IACzB,mBAAmB;CACtB,kBAAkB;IACf,2BAA2B;IAC3B,iCAAiC;AACrC;AACA;CACC,qCAAqC;CACrC,+DAA+E;CAC/E,mBAAmB;CACnB,kBAAkB;IACf,iCAAiC;IACjC,2BAA2B;AAC/B;AACA;CACC,sCAAsC;CACtC,+DAAgF;CAChF,mBAAmB;CACnB,kBAAkB;IACf,iCAAiC;IACjC,2BAA2B;AAC/B;;AAEA;IACI,yBAAyB;AAC7B;;;AAGA;IACI,2BAA2B;IAC3B,eAAe;AACnB;;AAEA;EACE,SAAS;EACT,yBAAyB;EACzB,mCAAmC;EACnC,kCAAkC;AACpC;;AAEA;EACE;aACW;AACb;;;AAGA;IACI,sBAAsB;AAC1B","sourcesContent":["@font-face {\n\tfont-family: 'Montserrat-large';\n\tsrc: url('../src/Fonts/Montserrat-SemiBold.otf') format('opentype');\n    /* font-weight: normal; */\n    font-weight: 600;\n\tfont-style: normal;\n    /* font-size:0.9rem !important; */\n    font-size:0.8rem !important;\n}\n@font-face {\n\tfont-family: 'Montserrat-small';\n\tsrc: url('../src/Fonts/Montserrat-LightItalic.otf') format('opentype');\n\tfont-weight: normal;\n\tfont-style: normal;\n    /* font-size:0.7rem !important; */\n    font-size:0.6rem !important;\n}\n@font-face {\n\tfont-family: 'Montserrat-medium';\n\tsrc: url('../src/Fonts/Montserrat-Light.otf') format('opentype');\n\tfont-weight: normal;\n\tfont-style: normal;\n    /* font-size:0.8rem !important; */\n    font-size:0.7rem !important;\n}\n@font-face {\n\tfont-family: 'Montserrat-mdm-italic';\n\tsrc: url('../src/Fonts/Montserrat-MediumItalic.otf') format('opentype');\n    /* font-weight: normal; */\n    font-weight: normal;\n\tfont-style: italic;\n    font-size:0.7rem !important;\n    /* font-size:0.9rem !important; */\n}\n@font-face {\n\tfont-family: 'Montserrat-Thin-italic';\n\tsrc: url('../src/Fonts/MontserratAlternates-ThinItalic.otf') format('opentype');\n\tfont-weight: normal;\n\tfont-style: normal;\n    /* font-size:0.8rem !important; */\n    font-size:0.9rem !important;\n}\n@font-face {\n\tfont-family: 'Montserrat-Light-italic';\n\tsrc: url('../src/Fonts/MontserratAlternates-LightItalic.otf') format('opentype');\n\tfont-weight: normal;\n\tfont-style: normal;\n    /* font-size:0.8rem !important; */\n    font-size:0.9rem !important;\n}\n\n.dropdown-icon-size {\n    font-size: 1vh !important;\n}\n\n\n.video-btn-icon-size {\n    font-size: 1.7vh !important;\n    padding: 0.3rem;\n}\n\nbody {\n  margin: 0;\n  font-family: 'Montserrat';\n  -webkit-font-smoothing: antialiased;\n  -moz-osx-font-smoothing: grayscale;\n}\n\ncode {\n  font-family: source-code-pro, Menlo, Monaco, Consolas, 'Courier New',\n    monospace;\n}\n\n\n.width-100{\n    width: 100% !important;\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
